// @ts-check

import { s3Url } from '../utils';
import { useLink } from '../link';
import { themeFactory } from './lib';

export const agencyTheme = themeFactory({
  colors: {
    primary: '#0007A7',
    gradient: ['#080D8F', '#0007A7', '#0000C1'],
    background: '#f5f8fa',
  },
  name: 'agency',
  portalName: 'Agency',
  css: s3Url({ agency: 'agency', path: 'theme.css' }),
  footerLogo: s3Url({ agency: 'agency', path: 'footer-logo.png' }),
  portalUrls: {
    development: useLink({ product: 'portal', agency: 'agency', env: 'dev' }),
    staging: useLink({ product: 'portal', agency: 'agency', env: 'stg' }),
    production: useLink({ product: 'portal', agency: 'agency', env: 'prod' }),
  },
  headerSecondaryLogo: null,
  favicon: s3Url({ agency: 'agency', path: 'favicon.svg' }),
  copyright: 'Agency',
  logo: s3Url({ agency: 'agency', path: 'agency.png' }),
  logos: {
    analytics: s3Url({ agency: 'agency', path: 'agency.png' }),
    'media planner': s3Url({ agency: 'agency', path: 'agency.png' }),
    'admin hierarchy': s3Url({ agency: 'agency', path: 'agency.png' }),
  },
});

export const Agency = Symbol.for(agencyTheme.name);
